import React from "react";
import Button from "react-bootstrap/Button";
import Jumbotron from "react-bootstrap/Jumbotron";
import Alert from "react-bootstrap/Alert";
import "./LoginPage.css";
import { connect } from "react-redux";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { signInRequestAction } from "../../redux/actions/loginPage";
import { withCookies } from "react-cookie";
import { withRouter } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.responseFacebook = this.responseFacebook.bind(this);
  }

  responseFacebook(response) {
    if (response.accessToken == null) {
      return;
    }

    const { cookies, history } = this.props;
    this.props.signInRequestAction(cookies, history);
  }

  render() {
    return (
      <React.Fragment>
        <Jumbotron className="banner_container">
          <h1>Kono Article Warehouse</h1>
        </Jumbotron>

        <div className="error">
          <Alert
            variant="danger"
            className={this.props.loginError !== null ? "" : "hidden"}
          >
            {this.props.loginError}
          </Alert>
        </div>

        <div className="btn_container">
          <FacebookLogin
            appId={process.env.REACT_APP_FB_APP_ID}
            cookie={true}
            callback={this.responseFacebook}
            render={renderProps => (
              <Button
                variant="primary"
                size="lg"
                className="btn"
                disabled={this.props.isLoading}
                onClick={renderProps.onClick}
              >
                Sign In
              </Button>
            )}
          />

          <div> {this.props.isLoading && <Spinner animation="grow" />}</div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { loginPage } = state;
  return loginPage;
};

const mapDispatchToProps = {
  signInRequestAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCookies(withRouter(LoginPage)));
